
export default function AppObjectFieldObjectId({ field, value }) {
  console.log(`AppObjectFieldObjectId rendered: ${field.name}`)

  return (
    <div>
      {value}
    </div >
  )
}
